import { WHITE, GREEN, GREY } from '../../theme/ColorConstants';
export const getStatusIndicatorBorderColor = () => WHITE;
export const getStatusIndicatorOnlineBackgroundColor = () => GREEN;
export const getStatusIndicatorOfflineBackgroundColor = () => GREY;